import { call, put, select, takeLatest } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import noticeItmes from "../../../features/Notice/dummy/noticeItems";
import { sefInfinity } from "../productSearch/productSearch";

// Initial state
const initialState = {
  loading: false,
  loaded: null,
  data: null,
  noticeList: [],
  count: null,
  infinity: true, // 무한스크롤 활성 상태
};

// Slice
const getNoticeListSlice = createSlice({
  name: "getNoticeList",
  initialState,
  reducers: {
    initNoticeList(state) {
      return {
        ...state,
        loading: false,
        loaded: null,
        data: null,
        noticeList: [],
        count: null,
        infinity: true, // 무한스크롤 활성 상태
      };
    },
    findNoticeList(state) {
      return {
        ...state,
        noticeList: [],
        loading: true,
        error: false,
        loaded: false,
      };
    },
    findMoreNoticeList(state) {
      return { ...state, loading: true, error: false };
    },
    fetchDataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: false,
        loaded: true,
      };
    },
    fetchDataFailure(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: action.payload,
        loaded: true,
      };
    },
    setNoticeList(state, action) {
      const { data, count } = action.payload;
      return {
        ...state,
        noticeList: [...state.noticeList, ...data],
        count,
      };
    },
    setInfinity(state) {
      return {
        ...state,
        infinity: false,
      };
    },
  },
});

export const {
  initNoticeList,
  findNoticeList,
  findMoreNoticeList,
  fetchDataSuccess,
  fetchDataFailure,
  setNoticeList,
  setInfinity,
} = getNoticeListSlice.actions;

export default getNoticeListSlice.reducer;

//saga
function* fetchDataSaga(action) {
  const peerIp = yield select((state) => state.peerIp.ip);
  try {
    const currentDataLength = yield select(
      (state) => state.getNoticeList.noticeList.length
    );
    const total = yield select((state) => state.getNoticeList.count);
    if (total !== null && currentDataLength >= total && total !== 0) {
      // 이미 모든 데이터를 불러왔을 경우, 추가 요청하지 않음
      yield put(sefInfinity());
      return;
    }

    const { headers = {}, apiUrl, data } = action.payload;
    const apiService = axios.create({
      headers: {
        ...headers,
        user_ip: peerIp
      }
    });

    const response = yield call(apiService.post, apiUrl, data);
    // const response = noticeItmes;

    yield put(fetchDataSuccess(response.data));
    if (response?.data) {
      const { code, data, count } = response.data;
      // const { data, total } = datas;
      if (code === "0200") {
        yield put(setNoticeList({ data, count }));
      }
    }
  } catch (error) {
    yield put(fetchDataFailure(error));
  }
}

// API 호출을 감시하는 Saga 함수
export function* getNoticeListSaga() {
  yield takeLatest(findNoticeList.type, fetchDataSaga);
  yield takeLatest(findMoreNoticeList.type, fetchDataSaga);
}
